const rail = {
  rails: "ราง", // translated
  senior: "อาวุโส", // translated
  seniors: "ผู้สูงอายุ", // translated
  youths: "เยาวชน", // translated
  yearOld: "ปี", // translated
  yearsOld: "ปี", // translated
};

export default rail;
